export default {"src":"/_next/static/media/shape2.bc604dad.svg","height":60,"width":103};